import { faCheck, faCreditCard } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useIntl } from 'react-intl'
import { styled } from 'styled-components'

import { Tag, TagType, FormattedMessage } from '@b-stock/fe-core/bstock-react'

// Shared "Credit Card Approved" tag used on the LDP header (`ListingTags`,
// `ListingTagsV2`) and the ALP listing card (`BaseListingCard2025`) so the
// surfaces stay visually consistent (GLOB-4182). Purely presentational — each
// call site gates rendering on `ENABLE_CC_SURFACING` + `isCreditCardEnabled`.
const ns = 'Listing.tags'

const IconWrapper = styled.span`
  display: flex;
  gap: 0.25rem;
  padding: 0.125rem 0;
`

const Icon = styled(FontAwesomeIcon)`
  width: 1rem;
  height: 1rem;
  flex-shrink: 0;
  align-self: center;
`

export const CreditCardTag = ({
  'data-testid': dataTestId,
}: {
  'data-testid'?: string
}) => {
  const { formatMessage } = useIntl()

  return (
    <Tag
      type={TagType.buy_now}
      hoverMessage={<FormattedMessage id={`${ns}.creditCardApprovedHover`} />}
      data-testid={dataTestId}
    >
      <IconWrapper
        aria-label={formatMessage({ id: `${ns}.creditCardApprovedHover` })}
      >
        <Icon icon={faCreditCard} aria-hidden="true" />
        <Icon icon={faCheck} aria-hidden="true" />
      </IconWrapper>
    </Tag>
  )
}
